import styled from "styled-components";

export const StyledClock = styled.div`
    display: flex;
    justify-content: end;
    font-family: 'Courier Prime', monospace;
    font-size: 13px;
`;